namespace GeniuzPOS.AdvPromo {
    export interface Adv05ItemDetailsRow {
        Id?: number;
        PmId?: string;
        StartPromoDate?: string;
        EndPromoDate?: string;
        PmTypeDesc?: string;
        PmType?: number;
        PmGroupId?: string;
        PmExtCode?: string;
        PmDesc?: string;
        ListFg?: number;
        PPtype?: number;
        PmStepNo?: number;
        ItemType?: number;
        AssortFg?: number;
        SkuCode?: string;
        PluCode?: string;
        PluShortDesc?: string;
        StyleCode?: string;
        StyleName?: string;
        CatCode?: string;
        CatName?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
        BrandCode?: string;
        BrandName?: string;
        SupplCode?: string;
        SupplName?: string;
        Normalprice?: number;
        PromotionPrice?: string;
        DiscPc?: string;
        Remark?: string;
    }

    export namespace Adv05ItemDetailsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PmId';
        export const localTextPrefix = 'AdvPromo.Adv05ItemDetails';
        export const lookupKey = 'AdvPromo.Adv05ItemDetails';

        export function getLookup(): Q.Lookup<Adv05ItemDetailsRow> {
            return Q.getLookup<Adv05ItemDetailsRow>('AdvPromo.Adv05ItemDetails');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '4ADVANCED_PROMOTION:รายงาน:รายการสินค้าร่วมโปร:View';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            PmId = "PmId",
            StartPromoDate = "StartPromoDate",
            EndPromoDate = "EndPromoDate",
            PmTypeDesc = "PmTypeDesc",
            PmType = "PmType",
            PmGroupId = "PmGroupId",
            PmExtCode = "PmExtCode",
            PmDesc = "PmDesc",
            ListFg = "ListFg",
            PPtype = "PPtype",
            PmStepNo = "PmStepNo",
            ItemType = "ItemType",
            AssortFg = "AssortFg",
            SkuCode = "SkuCode",
            PluCode = "PluCode",
            PluShortDesc = "PluShortDesc",
            StyleCode = "StyleCode",
            StyleName = "StyleName",
            CatCode = "CatCode",
            CatName = "CatName",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            SupplCode = "SupplCode",
            SupplName = "SupplName",
            Normalprice = "Normalprice",
            PromotionPrice = "PromotionPrice",
            DiscPc = "DiscPc",
            Remark = "Remark"
        }
    }
}
